import { useFieldValue } from "hooks";
import { useSelector } from "react-redux";
import { getBillingTags } from "selectors";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import React from "react";

export function GeneralHeader() {
  const name = useFieldValue("name") || "";
  const billingTagIds = useFieldValue("billing_tags") || [];
  const isGrouped = Boolean(useFieldValue("invoice_line_item_template"));
  const billingTagByIdLookup = useSelector(getBillingTags);
  const billingTags = billingTagIds.map(tagId => billingTagByIdLookup[tagId]);

  return (
    <Row>
      <div>
        <SubtleBadge>General</SubtleBadge>
      </div>
      <Row alignCenter flexWrap>
        <CollapseLabel>{name}</CollapseLabel>
      </Row>
      <Row alignCenter flexWrap>
        {isGrouped && <CollapseLabel>Grouped</CollapseLabel>}
      </Row>
      <Row alignCenter flexWrap>
        {billingTags.map(billingTag => (
          <CollapseLabel key={billingTag.id} className="ml-2">
            {billingTag.name}
          </CollapseLabel>
        ))}
      </Row>
    </Row>
  );
}
